import { useAuthStore } from "@/lib/auth-store";

/**
 * ¿El usuario en sesión tiene ALGUNO de los permisos? Lectura directa del auth store
 * (fuera de React) · para `loader`/`beforeLoad` de las rutas.
 *
 * Hotspot 94 · las rutas protegidas con `<PermissionGate>` precargan datos en su `loader`,
 * que corre ANTES de renderizar el gate: sin el permiso, el endpoint respondía 403 y se veía
 * el `errorComponent` (error técnico) en lugar del aviso «Acceso restringido». Los loaders
 * consultan esto primero y, sin permiso, no precargan nada · el gate muestra el aviso.
 * El layout `_authed-tw` ya esperó la rehidratación de la sesión antes de correr los loaders.
 */
export function tienePermisoEnSesion(permisos: ReadonlyArray<string>): boolean {
  const mios = useAuthStore.getState().user?.permisos ?? [];
  return permisos.some((p) => mios.includes(p));
}
